export default __webpack_public_path__ + "static/media/team-mosaic-02.585d732e.jpg";